import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAnalytics } from '../../context/AnalyticsContext'
import './reading.css'

const OnboardingReading = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { trackEvent } = useAnalytics()
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const start = Date.now()
    const duration = 4000
    const tick = () => {
      const p = Math.min(1, (Date.now() - start) / duration)
      setProgress(p)
      if (p < 1) requestAnimationFrame(tick)
    }
    const raf = requestAnimationFrame(tick)
    const id = setTimeout(() => {
      trackEvent('funnel_reading_completed', { step: 6 })
      navigate('/onboarding/teaser')
    }, duration)
    return () => {
      cancelAnimationFrame(raf)
      clearTimeout(id)
    }
  }, [navigate, trackEvent])

  return (
    <div className="reading-page">
      <div className="reading-progress-track" aria-hidden="true">
        <div className="reading-progress-fill" style={{ width: `${progress * 100}%` }} />
      </div>
      <h1 className="reading-title">{t('onboarding.readingAligningStars')}</h1>
      <p className="reading-text">
        {t('onboarding.readingText')}
      </p>
    </div>
  )
}

export default OnboardingReading

